//system
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService, HttpServiceConfig } from './common/http.service';

//services
import { LogService } from './common/log.service';

//models
import { SessionWaitlist } from 'src/app/models/studio/session-details';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class SessionWaitlistService {

  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  get(sessionId: number): Promise<SessionWaitlist[]> { 
    return this.httpService.getPromise<SessionWaitlist[]>(`SessionWaitlist/BySession/${sessionId}`);
  }

  add(sessionWaitlist: Partial<SessionWaitlist>): Observable<boolean> {
    return this.httpService.post<boolean>(`SessionWaitlist`, sessionWaitlist);
  }

  remove(sessionWaitlist: Partial<SessionWaitlist>): Observable<boolean> {
    return this.httpService.delete<boolean>(`SessionWaitlist`, sessionWaitlist);
  }
}